import { Site } from '@/types/initialData';

export function registerInterceptor(site: Site) {
  // @ts-ignore
  if (!window.gPolly) {
    // eslint-disable-next-line no-console
    console.error('Could not find gPolly.');
  }

  if (!site?.environment?.endpoints?.polly) {
    // eslint-disable-next-line no-console
    console.error(
      'Expected polly in the endpoints object: ' + site.environment.endpoints
    );
    return;
  }

  // @ts-ignore
  window.gPolly.registerRequestInterceptor((_requestUrl, requestInit) => {
    const newUrl = site.environment.endpoints.polly.endpoint;
    const request = requestInit;

    const additionalHeaders = {
      'X-Requested-At': site.environment.endpoints.polly.timestamp,
      'X-Auth-Token': site.environment.endpoints.polly.hash
    };
    request.headers = { ...request.headers, ...additionalHeaders };

    return new Request(newUrl, request);
  });
}
